import { Component, OnInit, OnDestroy } from '@angular/core';
import { OrdersService } from 'src/app/services/orders.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { MetaService } from 'src/app/services/meta.service';
import { DialogAddOrderPaymentComponent } from 'src/app/components/dialogs/dialog-add-order-payment/dialog-add-order-payment.component';
import { Subscription } from 'rxjs';

import * as moment from 'moment';

@Component({
  selector: 'app-orders-table',
  templateUrl: './orders-table.component.html',
  styleUrls: ['./orders-table.component.css'],
  host: { '(document:keypress)': 'handleKeyboardEvent($event)' }
})
export class OrdersTableComponent implements OnInit, OnDestroy {

  isLoading: boolean = false;
  orders = [];
  queryMismatch = false;
  serviceAgents = [];

  data = {
    startDate: '',
    endDate: ''
  }

  onSearchFilters: FormData;
  ordersSub: Subscription;

  public search = {
    startDate: '',
    endDate: '',
    transactionType: '',
    status: '',
    email: '',
    mobile: '',
    serviceAgent: '',
    ipgReceipt: ''
  }

  constructor(private ordersService: OrdersService, private metaService: MetaService, private snackbar: MatSnackBar, private dialog: MatDialog) { }

  ngOnInit() {
    this.isLoading = true;
    this.metaService.getMetaData().subscribe(result => {
      if (result.success) {
        this.serviceAgents = result.data.serviceAgents

        this.data.startDate = result.data.query_dates.START_DATE;
        this.data.endDate = result.data.query_dates.END_DATE;

        const data = new FormData();
        data.append('startDate', this.data.startDate);
        data.append('endDate', this.data.endDate);

        this.ordersService.getAllOrdersAdAdmin(data).subscribe(result => {
          this.isLoading = false;
          this.orders = result.data;
        }, error => {
          this.isLoading = false;
          this.queryMismatch = true;
          this.snackbar.open(error.error.data, 'Dismiss', {
            duration: 3000
          });
        });
      }
    });

    this.ordersSub = this.ordersService.getOrdersUpdated().subscribe(result => {
      this.orders = result;
    });
  }

  onSearch() {
    this.isLoading = true;
    const data = new FormData();

    if (this.search.startDate == '') {
      data.append('startDate', this.data.startDate.toString());
    }

    if (this.search.endDate == '') {
      data.append('endDate', this.data.endDate.toString());
    }

    if (this.search.startDate !== '') {
      const date = moment(this.search.startDate).format('DD-MM-YYYY').toString();
      data.append('startDate', date);
    }

    if (this.search.endDate !== '') {
      const date = moment(this.search.endDate).format('DD-MM-YYYY').toString();
      data.append('endDate', date);
    }

    if (this.search.transactionType == '' || this.search.transactionType == 'none') {
      data.delete('transactionType')
    } else {
      data.append('transactionType', this.search.transactionType);
    }

    if (this.search.status == '' || this.search.status == 'none') {
      data.delete('status');
    } else {
      data.append('status', this.search.status);
    }

    if (this.search.email == '') {
      data.delete('email');
    } else {
      data.append('email', this.search.email);
    }

    if (this.search.serviceAgent == '' || this.search.serviceAgent == 'none') {
      data.delete('serviceAgent');
    } else {
      data.append('serviceAgent', this.search.serviceAgent);
    }

    if (this.search.ipgReceipt == '' || this.search.ipgReceipt == 'none') {
      data.delete('ipgReceipt');
    } else {
      data.append('ipgReceipt', this.search.ipgReceipt);
    }

    if (this.search.mobile == '') {
      data.delete('mobile');
    } else {
      data.append('mobile', this.search.mobile);
    }

    this.onSearchFilters = data;

    this.ordersService.getAllOrdersAdAdmin(data).subscribe(result => {
      this.isLoading = false;
      this.queryMismatch = false
      this.orders = result.data;
    }, error => {
      this.isLoading = false;
      this.queryMismatch = true;
      this.orders = []
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onAddPayment(ID) {
    this.dialog.open(DialogAddOrderPaymentComponent, {
      data: {
        _id: ID,
        filter: this.onSearchFilters
      }
    });
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == 'Enter' && event.shiftKey == false) {
      this.onSearch();
    } else if (event.key == 'Enter' && event.shiftKey == true) {
      this.onClear();
    }
  }

  onClear() {
    this.search = {
      startDate: '',
      endDate: '',
      transactionType: '',
      status: '',
      email: '',
      mobile: '',
      serviceAgent: '',
      ipgReceipt: ''
    }

    const data = new FormData();

    data.append('startDate', this.data.startDate.toString());
    data.append('endDate', this.data.endDate.toString());

    this.ordersService.getAllOrdersAdAdmin(data).subscribe(result => {
      this.isLoading = false;
      this.queryMismatch = false
      this.orders = result.data;
    }, error => {
      this.isLoading = false;
      this.queryMismatch = true;
      this.orders = []
      this.snackbar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  ngOnDestroy() {
    this.ordersSub.unsubscribe();
  }
}
